import { render, staticRenderFns } from "./Oligoelements.vue?vue&type=template&id=d5aa1d80&scoped=true&"
import script from "./Oligoelements.vue?vue&type=script&lang=js&"
export * from "./Oligoelements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5aa1d80",
  null
  
)

export default component.exports